import styled from 'styled-components';
import { variant } from 'styled-system';
import { motion } from 'framer-motion';

import { ThemeUtilities } from '../../../theme';
import { Size, Variant } from './types';

export const Container = styled.ul<{ containerVariant: Variant }>`
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;

  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'Tabs', 'containerVariant')
    )};
`;

export const Tab = styled(motion.li)<{ size: Size }>`
  user-select: none;
  cursor: pointer;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Tabs', 'size'))};
`;

export const Wrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
`;

export const Underline = styled(motion.div)<{ variant: Variant }>`
  position: absolute;
  bottom: -1px;
  height: 2px;
  width: 100%;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Tabs', 'variant'))};
`;
